import OptionToggle from '~/components/OptionToggle';
import React from 'react';

const HidePriceDurationSetting = ({ settings, setSettings }) => {
    return (
        <>
            <OptionToggle
                value={settings?.hideDuration}
                onChange={value =>
                    setSettings({ ...settings, hideDuration: value })
                }
                title="Hide Duration"
                description="Don’t show event type durations when booking"
            />
            <OptionToggle
                value={settings?.hidePrice}
                onChange={value =>
                    setSettings({ ...settings, hidePrice: value })
                }
                className="mt-4"
                title="Hide Prices"
                description="Don’t show prices for event types when booking"
            />
            <OptionToggle
                value={settings?.hideDescription}
                onChange={value =>
                    setSettings({ ...settings, hideDescription: value })
                }
                className="mt-4"
                title="Hide Description"
                description="Don't show event type descriptions when booking"
            />
        </>
    );
};

export default HidePriceDurationSetting;
